<template>
  <div class="p-3 text-left">
    <h2>{{ $t('general.mixer_requests') }}</h2>
    <hr />
    <transition name="page" appear>
      <el-card>
        <table class="el-table el-table--striped el-tab">
          <thead>
            <tr>
              <th>{{ $t('general.created_at') }}</th>
              <th>{{ $t('general.type') }}</th>
              <th>{{ $t('general.company') }}</th>
              <th>{{ $t('general.email') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="request in requests" :key="request.id" class="cursor-pointer" @click="detailRequest(request)">
              <td>{{ request.createdAt.toLocaleString() }}</td>
              <td>{{ request.get('type') }}</td>
              <td>{{ request.get('user').get('company') }}</td>
              <td>{{ request.get('user').get('email') }}</td>
              <td>
                <el-tooltip class="item" effect="dark" content="Detail" placement="top-start">
                  <el-button type="info" circle>
                    <i class="el-icon-zoom-in" />
                  </el-button>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </el-card>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AdminMixerRequestsView',
  components: {},
  props: {},
  async mounted() {
    await this.onLoad();
  },
  destroyed() {},
  data() {
    return {
      requests: [],
    };
  },
  computed: {},
  methods: {
    async onLoad() {
      let query = new this.$parse.Query('MixerRequest');
      query.limit(3000);
      query.include('user');
      query.addDescending('createdAt');
      this.requests = await query.find();
    },
    detailRequest(request) {
      this.$router.push({ name: this.$routeNames.ADMIN_MIXER_REQUEST_DETAIL_PAGE_ROUTE, params: { id: request.id } });
    },
  },
};
</script>

<style scoped></style>
